import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.response.use((response) => {
  if (response?.data?.result !== 'SUCCESS') {
    throw response;
  } else {
    return response.data;
  }
}, (error) => {
  throw error;
});

export default {
  addCompany(newCompany) {
    return api
      .post('/companies', newCompany)
      .then((data) => data.company);
  },

  updateCompany(updatedCompany) {
    return api
      .post(`/companies/${updatedCompany.id}`, updatedCompany)
      .then((data) => data.company);
  },

  deleteCompany(companyId) {
    return api
      .delete(`/companies/${companyId}`);
  },

  getAllCompanies() {
    return api
      .get('/companies/all')
      .then((data) => data.companies);
  },

  getCompanyByReference(reference) {
    return api
      .get(`/companies/reference/${reference}`)
      .then((data) => data.company);
  },

  getReservationTypes(clientId) {
    return api
      .get(`/companies/reservation-types/${clientId}`)
      .then((data) => data.reservationTypes);
  },

  setEnabledReservationTypes(companyId, selectedReservationTypes) {
    return api
      .post(`/companies/reservation-types/enabled/${companyId}`, selectedReservationTypes);
  },

  getEnabledReservationTypes(companyId) {
    return api
      .get(`/companies/reservation-types/enabled/${companyId}`)
      .then((data) => data.reservationTypes);
  },

  getProperties(clientId) {
    return api
      .get(`/companies/properties/${clientId}`)
      .then((data) => data.properties);
  },

  setEnabledProperties(companyId, selectedProperties) {
    return api
      .post(`/companies/properties/enabled/${companyId}`, selectedProperties);
  },

  getEnabledProperties(companyId) {
    return api
      .get(`/companies/properties/enabled/${companyId}`)
      .then((data) => data.properties);
  },
};
